mainApp.component('directoryServices', {
    templateUrl: '/public/components/directory-services.component.html',
    bindings: {
        changesListener: '&',
        modelListener: '&'
    },
    controller: directoryServicesController
});


function directoryServicesController($scope, $state, $timeout, GeneralUtilsService, IntervalService) {
    var $ctrl = this;
    $scope.timer = null;
    $scope.loaders = {groups:true};
    $scope.controllersdatamodified = false;
    $scope.wmicontrollersdatamodified = false;
    $scope.domainsdatamodified = false;
    $scope.uaExceptionsmodified = false;
    $scope.showDomainControllerItem = 'host';
    $scope.progressReset = false;


    $ctrl.$onInit = function() {
         loadExternalSystems();

        if (isSystemLogin) {
            $scope.isSystemLogin = true;
        }
    }

    $scope.$on('modelReloadedEvent', function (event, data) {
         loadExternalSystems();
    });

     $scope.$on('saveExternalSystem', function (event, data) {
             saveChanges();
    });

   //checks if there were changed in the component and calls the changes listener
    $ctrl.$doCheck = function() {
        if (!$ctrl.changesListener)
            return;

        var isChangedNow = !angular.equals($scope.externalSystem, $ctrl.original);

        //check if listener was already called and updates about having changes
        if ($ctrl.hasChanges === isChangedNow)
            return;

        $ctrl.hasChanges = isChangedNow;
        $ctrl.changesListener({isDirty: $ctrl.hasChanges, componentName: 'directoryServices'});
    }

  	$scope.openChooseGroupDlg = function (from) {
  	    $scope.groupFilterSource = from;
        $scope.progressReset = new Date().getTime();
          if ($scope.domain.id) {
              store.fetch({
                  path: '/queryGroups',
                  queryParams: { domainId: $scope.domain.id },
                  success: function (data) {
                      $scope.groupsProgressId = data.id;
                      IntervalService.dynamicInterval(updateProgress, $scope.$id + $scope.progressReset, 'directoryServiceProgress', true);
                      $scope.$digest();
                  },
              });
              $scope.$root.openPopup('chooseGroupsDLg');
              $scope.loaders.groups = true;
              $scope.selectGroups = true;
  		}
  	};

    let updateProgress = () => {
        store.fetch({
            path: '/progress',
            queryParams: { id: $scope.groupsProgressId },
            success: function (data) {
                if (data.progress == 100 || data.status === 'ERROR') {
                    IntervalService.cancelDynamicInterval($scope.$id + $scope.progressReset, 'directoryServiceProgress');
                }
                if (data.progress == 100) {
                    $scope.groupsModified = new Date().getTime();
                    var groupDnSplittingRegex = /[^##]+(\##[^##]+)?/g;
                    if ($scope.groupFilterSource =="UA") {
                        $scope.allGroupsConfig.selectedItems = [];
                        if ($scope.domain.groupUaFilter) {
                            var groupNames = $scope.domain.groupUaFilter.split(',');
                            var groupDns = $scope.domain.groupUaDNFilter.match(groupDnSplittingRegex);
                            for (let i=0; i<groupNames.length; i++) {
                                $scope.allGroupsConfig.selectedItems.push({name: groupNames[i], dn: groupDns[i], id: groupDns[i] + groupNames[i]});
                            }
                        }
                    }
                    else {
                        $scope.allGroupsConfig.selectedItems = [];
                        if ($scope.domain.groupFilter) {
                            var groupNames = $scope.domain.groupFilter.split(',');
                            var groupDns = $scope.domain.groupDNFilter.match(groupDnSplittingRegex);
                            for (let i=0; i<groupNames.length; i++) {
                                $scope.allGroupsConfig.selectedItems.push({name: groupNames[i], dn: groupDns[i], id: groupDns[i] + groupNames[i]});
                            }
                        }
                    }
                    $scope.loaders.groups = false;
                }
                else if (data.status === 'ERROR') {
                    $scope.$root.handleServerResponse(data, 'newDomain', '');
                    $scope.$root.closePopup('chooseGroupsDLg');
                }
                $scope.$digest();
            },
        });
    }

//      ng-table configs

    //Groups (selection in dialog) configuration
  	$scope.allGroupsConfig = {
    		dataURL: function () {
    			return '/viewGroups?domainId=' + $scope.domain.id + '&progressId=' + $scope.groupsProgressId;
    		},
    		showTable: false,
    		innerLoader: true,
    		fields: [
                { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
    		],
    		parseData: function(items) {
    		        items.forEach(function (item) {item.id = item.dn + item.name;});
    		        return items;
    		    },
    		type: '',
    		titleSearch:"Groups",
    		success: $scope.loaders.groups = true,
    		actions: [],
    	};

    // Domain controllers table configuration
    $scope.controllersConfig = {
        dataURL: function () {
            if (!$scope.domain.id || $scope.domain.id < 0) {
                return null;
            }
            return '/domainControllers?domainId=' + $scope.domain.id;
        },
        items: [],
        showTable: false,
        fields: [
            { label: 'Host', path: 'host', template: "<span>{{item.host?(item.host + ':' + item.port):(item.siteName + ':' + item.subnet.name)}}</span>" },
        ],
        type: 'DomainController',
        actions: [],
        selectedItems: [],
        pageSize: 10,
        defer: true,
        specialActions: [
            {
                func: function (selectedItems) {
                if(!$scope.domain.domainControllers){
                    $scope.domain.domainControllers = [];
                }
                    $scope.newDomainController = {};
                    $scope.$root.openPopup('addDomainControllers');
                    $scope.subnetsConfig.selectedItems = [];
                    $scope.controllersConfig.items.forEach(function (item) {
                        if (item.subnet)
                            $scope.subnetsConfig.selectedItems.push(item.subnet);
                    });
                },
                icon: 'add',
                tooltip: 'New',
            },
            {
                func: function (selectedItems) {
                    let deletedControllers = [];
                    selectedItems.forEach(function (item) {
                        for (var i = 0; i < $scope.controllersConfig.items.length; i++) {
                            var controller = $scope.controllersConfig.items[i];
                            if (controller.id === item.id) {
                                $scope.domain.domainControllers.splice(i, 1);
                                $scope.controllersConfig.items.splice(i, 1);
                                if (item.id > 0) {
                                    deletedControllers.push(item);
                                }

                            }
                        }
                    });
                    if (!$scope.domain.itemsToDelete) { $scope.domain.itemsToDelete = {}; }
                    if (!$scope.domain.itemsToDelete.domainControllers) { $scope.domain.itemsToDelete.domainControllers = []; }
                    $scope.domain.itemsToDelete.domainControllers = $scope.domain.itemsToDelete.domainControllers.concat(deletedControllers);
                },
                icon: 'delete',
                tooltip: 'Delete',
            },
        ],
        noSearch: true
    };

    $scope.subnetsConfig = {
        titleSearch: true,
        dataURL: function () {
            return '/subnets?accountId=' + $state.params.accountId;
        },
        showTable: false,
        fields: [
            { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Site', name: 'siteName', template: '<span>{{item.siteName}}</span>' },
            { label: 'Network', path: 'interfaceName', template: "<span>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>" },
            { label: 'IP', path: 'subnet', template: '<span>{{item.translatedSubnet}}</span>' }
        ],
        type: 'Subnet',
        actions: [],
        selectedItems: [],
        pageSize: 5,
    };

    $scope.wmiSourceConfig = {
        dataURL: function () {
            if(!$scope.domain.id || $scope.domain.id < 0 ){
                return null;
            }
            return '/wmiSource?domainId=' + $scope.domain.id;
        },

        items: [],
        processData: function (items) {
            items.forEach(function(item) {
                item.showEditPW = false;
            });
            this.origDomainItems = angular.copy(items);
        },
        showTable: false,
        fields: [
            { label: 'Host', path: 'host', template: "<span>{{item.host?(item.host + ':' + item.port):(item.siteName + ':' + item.subnet.name)}}</span>" },
            { label: 'Username', path: 'username', template: "<span><input type='text' class='form-control' ng-model='item.username' /></span>" },
            { label: 'Password', path: 'pw', template: "<div ng-click='tableConfig.enablePwChanage(item)' ng-show='item.showEditPW != true' ng-scope>Change Password &nbsp;<span class='glyphicon glyphicon-lock'></span></div><input ng-show='item.showEditPW == true' type='password' class='form-control' ng-model='item.pw'  autocomplete='New-password'/>", "noSort":true},
            { label: 'DC Connection Status', path: 'test', template: "<button ng-show='item.id>0' type='submit' class='btn btn-save cato-btn btn-sm' ng-click='tableConfig.testWmiConnection(item)'>Show Status</button>", "noSort":true},
        ],
        enablePwChanage: function (item) {
            item.showEditPW = true;
        },
        testWmiConnection: function (item) {
            testWmiConnection(item);
        },
        type: 'domainController',
        actions: [],
        selectedItems: [],
        pageSize: 10,
        defer: true,
        specialActions: [
            {
                func: function (selectedItems) {
                    $scope.newDomainController = {};
                    $scope.$root.openPopup('addWmiSource');
                    $scope.subnetsConfig.selectedItems = [];
                    $scope.wmiSourceConfig.items.forEach(function (item) {
                        if (item.subnet)
                            $scope.subnetsConfig.selectedItems.push(item.subnet);
                    });
                },
                icon: 'add',
                tooltip: 'New',
            },
            {
                func: function (selectedItems) {
                    selectedItems.forEach(function (item) {
                        for (var i = 0; i < $scope.wmiSourceConfig.items.length; i++) {
                            var controller = $scope.wmiSourceConfig.items[i];
                            if (controller.id == item.id) {
                                var deletedControllers = $scope.wmiSourceConfig.items.splice(i, 1);
                                if (!$scope.domain.itemsToDelete) { $scope.domain.itemsToDelete = {}; }
                                if (!$scope.domain.itemsToDelete.wmiDomainControllers) { $scope.domain.itemsToDelete.wmiDomainControllers = []; }
                                $scope.domain.itemsToDelete.wmiDomainControllers = $scope.domain.itemsToDelete.wmiDomainControllers.concat(deletedControllers);
                                break;
                            }
                        }
                    });
                },
                icon: 'delete',
                tooltip: 'Delete',
            },
        ],
        id: 'wmiDomainControllers',
        noSearch: true,
    };

    var testDomainConnectionById = function (domainId) {
        $scope.progressReset = new Date().getTime();
             store.fetch({
                    path: '/testConnection',
                    queryParams: { domainId: domainId},
                    success: function (data) {
                        processDataFromResponse(data, true, false);
                    },
                });
            $scope.$root.openPopup('syncDLg');
        };

    const processDataFromResponse = (data) => {
        $scope.progressId = data.id;
        $scope.progress = data;
        $scope.viewProgress = true;
        $scope.$digest();
    }

    $scope.closeDialog = function(name){
        $scope.$root.closePopup(name);
        IntervalService.cancelDynamicInterval($scope.$id + $scope.progressReset, 'directoryServiceProgress');
        resetPopupParams();
    };

    const resetPopupParams = () => {
        $scope.progressId = null;
        $scope.groupsProgressId = null;
        $scope.progress = null;
        $scope.progressReset = false;
    }

     var deleteDomain = function (domainId) {
         for (var i = 0; i < $scope.domainsConfig.items.length; i++) {
             var domainsToDelete = [];
             var domain = $scope.domainsConfig.items[i];
             if (domain.id == domainId) {
                 if(domain.id > 0) {
                     domainsToDelete.push(domain.id);
                     ($scope.externalSystem.itemsToDelete.domains = $scope.externalSystem.itemsToDelete.domains || []).push($scope.domainsConfig.items[i]);
                     removeDomain(domainsToDelete, i);
                 }
                 else {
                    $scope.domainsConfig.items.splice(i, 1);
                 }
                 break;
              }
          }
     };

     function removeDomain(itemsToDelete, domainIndex) {
        store.remove({
            items: itemsToDelete,
            type: 'Domain',
            success: function (data) {
                $scope.$root.handleServerResponse(data, '', 'Domain was removed successfully');
                if (data.status !== 'ERROR') {
                        $scope.domainsConfig.items.splice(domainIndex, 1);
                        reload();
                }
            },
        });
     }

    // User awareness exceptions table in directory service screen
    $scope.uaExceptionsConfig = {
            dataURL: function () {
                return null;
            },
            parseData: function () {
                        return this.processData($scope.externalSystem.userAwarenessExceptions);
                    },
            items: [],
            processData: function (items) {
                items.forEach(function(item) {
                    item.$expiration = new Date(item.expiration); // expiration date
                    item.$expireDays = Math.ceil((item.$expiration.getTime() - new Date().getTime()) / 86400000); // calculate number of days until expiration based on the expiration date
                });
                return items;

            },
            showTable: false,
            fields: [
                  { label: 'What', path: 'ips', template: "<span><input type='text' class='form-control' ng-model='item.ips' placeholder='10.0.0.1,10.0.0.50' /></span>" , "noSort":true},
                  { label: 'Statically bind to', path: 'user', template: "<span>{{item.user.loginName}}</span>" , "noSort":true},
                  { label: 'Expire in', path: '$expireDays', template: "<span><input ng-click='tableConfig.updateExpiration(item)' ng-change='tableConfig.updateExpiration(item)' type='number' class='form-control' ng-model='item.$expireDays' /> Days</span>", "noSort":true},
                  { label: 'Expiration', path: 'expiration', template: "<span>{{item.$expiration | date }}</span>"},
                  { label: 'Enabled', path: 'enabled', template: "<div class='togglebutton no-disable'><label><input  type='checkbox' ng-model='item.enabled' /></label></div>"},
            ],
            updateExpiration: function (item) {
                item.expiration = new Date(moment().startOf('day').add(item.$expireDays, 'days').valueOf());
                item.$expiration = new Date(moment().startOf('day').add(item.$expireDays, 'days').valueOf());
            },
            sortList: [{sortField: "expiration", sortDir: "DESC" }],
            type: 'userAwarenessException',
            actions: [],
            selectedItems: [],
            pageSize: 10,
            defer: true,
            specialActions: [
                {
                    func: function (selectedItems) {
                        $scope.newUaException = {id: GeneralUtilsService.getRandomId(), $expireDays: 7, enabled: true};
                        $scope.uaExceptionsConfig.updateExpiration($scope.newUaException);
                        $scope.directoryServiceUsersTableConfig.selectedItems = [];
                        $scope.$root.openPopup('addUaExceptionDlg');
                    },
                    icon: 'add',
                    tooltip: 'New',
                },
                {
                    func: function (selectedItems) {
                        var deletedItems = [];
                        selectedItems.forEach(function (item) {
                            for (var i = 0; i < $scope.uaExceptionsConfig.items.length; i++) {
                                var controller = $scope.uaExceptionsConfig.items[i];
                                if (controller.id == item.id) {
                                    $scope.uaExceptionsConfig.items.splice(i, 1);
                                    deletedItems.push(controller);
                                }
                            }
                            deletedItems.forEach(function (dataItem) {
                                dataItem.user = null;
                            });
                        });

                        GeneralUtilsService.addItemsToDelete($scope.externalSystem, deletedItems, "userAwarenessExceptions");
                    },
                    icon: 'delete',
                    tooltip: 'Delete',
                },
            ],
            id: 'userAwarenessExceptions',
            noSearch: true,
        };

    // directory service users in adding new user awareness exception dialog
    $scope.directoryServiceUsersTableConfig = {
            dataURL: function () {
                return '/getAllDsUsers?accountId=' + $state.params.accountId;
            },
            fields: [{ label: 'Name', path: 'loginName', template: '<span>{{item.loginName}}</span>' }],
            parseData: function (dataItems) {
                let result = [];
                dataItems.forEach(function (dataItem) {
                    result.push(dataItem);
                });
                return result;
            },
            actions: [],
            selectedItems: [],
            selectIdentifier: 'item',
        };

    $scope.addedUsersConfig = {
        		titleSearch: "Added Users",
        		dataURL: function () {
                    return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=CREATED&entityType=ACCESSLOGIN';
        		},
        		showTable: false,
        		fields: [
                    { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
                    { label: 'E-mail', path: 'email', template: '<span>{{item.email}}</span>' },
        		],
        		type: '',
        		sortField: 'id',
        		hideCheckboxes: true,
        	};

    $scope.removedUsersConfig = {
        		titleSearch: "Deleted Users",
        		dataURL: function () {
        			return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=DELETED&entityType=ACCESSLOGIN';
        		},
        		showTable: false,
        		fields: [
                    { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
                    { label: 'E-mail', path: 'email', template: '<span>{{item.email}}</span>' },
        		],
        		type: '',
        		sortField: 'id',
        		hideCheckboxes: true,
        	};

    $scope.disabledUsersConfig = {
                titleSearch: "Disabled Users",
                dataURL: function () {
                    return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=DISABLED&entityType=ACCESSLOGIN';
                },
                showTable: false,
                fields: [
                    { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
                    { label: 'E-mail', path: 'email', template: '<span>{{item.email}}</span>' },
                ],
                type: '',
                sortField: 'id',
                hideCheckboxes: true,
            };

    $scope.modifiedUsersConfig = {
        		titleSearch: "Modified Users",
        		dataURL: function () {
        			return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=MODIFIED&entityType=ACCESSLOGIN';
        		},
        		showTable: false,
        		fields: [
                    { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
                    { label: 'E-mail', path: 'email', template: '<span>{{item.email}}</span>' },
        		],
        		type: '',
        		sortField: 'id',
        		hideCheckboxes: true,
        	};

    $scope.enabledUsersConfig = {
                titleSearch: "Enabled Users",
                dataURL: function () {
                    return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=ENABLED&entityType=ACCESSLOGIN';
                },
                showTable: false,
                fields: [
                    { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
                    { label: 'E-mail', path: 'email', template: '<span>{{item.email}}</span>' },
                ],
                type: '',
                sortField: 'id',
                hideCheckboxes: true,
            };

    $scope.addedGroupsConfig = {
        		titleSearch: "Added Groups",
        		dataURL: function () {
        			return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=CREATED&entityType=GROUP';
        		},
        		showTable: false,
        		fields: [
                    { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
        		],
        		type: '',
        		sortField: 'id',
        		hideCheckboxes: true,
        	};

    //TODO add domain name column to removed groups table once we have the source domain of the deleted group
    $scope.removedGroupsConfig = {
        		titleSearch: "Removed Groups",
        		dataURL: function () {
        			return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=DELETED&entityType=GROUP';
        		},
        		showTable: false,
        		fields: [
                    { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' }
        		],
        		type: '',
        		sortField: 'id',
        		hideCheckboxes: true,
        	};

    // Multi Domain table config
    $scope.domainsConfig = {
        dataURL: function () {
            return null;
        },
        defer: false,
        showTable: false,
        pageSize: 5,
        fields: [
            {'label':'a','path':'item','template':'<external-domain item="item" collapsed="true" test-connection-for-domain="tableConfig.testConnectionFunc(domainId)" delete-one-domain="tableConfig.deleteDomain(domainId)" vpnsyncdisabled="tableConfig.scimEnabled"></external-domain>'},
        ],
        specialActions : [
            {'icon':'add','tooltip':'New','func' :
                function() {
                    $timeout(function() {
                        $scope.externalSystem.domains.push({name: "New Domain",id: GeneralUtilsService.getRandomId()});
                        $scope.domainsdatamodified = new Date().getTime();
                    });
                }

            },
            {
                func: function (selectedItems) {
                    $scope.syncAllDomains();
                },
                icon: 'sync',
                tooltip: 'Sync all domains',
            }
          ],
        hideHead: true,
        noSearch: true,
        hideCheckboxes: true,
        actions: false,
        titleSearch: false,
        parseData: function () {
            return $scope.externalSystem.domains;
        },
        noDataMessage: 'Press + to add a new domain',
        testConnectionFunc: testDomainConnectionById,
        deleteDomain: deleteDomain,
    };

    // scope functions
    $scope.updateDomainControllersSelection = function () {

        removeUnselectedDomainControllers();

        addSelectedDomainControllers();

        if ($scope.newDomainController.host) {
            var newDC = { id: GeneralUtilsService.getRandomId(), host: $scope.newDomainController.host, port: $scope.newDomainController.port };
            $scope.controllersConfig.items.push(newDC);
            $scope.domain.domainControllers.push(newDC);
        }

        $scope.$root.closePopup('addDomainControllers');
    };

    // adding new exception after choosing user from dialog
    $scope.addNewUserAwarenessException = function () {
        if ($scope.directoryServiceUsersTableConfig.selectedItems.length === 1) {
            $scope.newUaException.user = $scope.directoryServiceUsersTableConfig.selectedItems[0];
            $scope.newUaException.name = 'exception_' + $scope.directoryServiceUsersTableConfig.selectedItems[0].name;
            $scope.uaExceptionsConfig.items.push($scope.newUaException);
            $scope.$root.closePopup('addUaExceptionDlg');
        } else {
            alert('Please choose single user');
        }
    };


    $scope.testLdapConnection = function () {
        if ($scope.$root.hasChanges()) {
            if (confirm('You have unsaved changes.Do you want to save them first?')) {
                saveChanges(doOpenSync);
            } else {
               testDomainConnectionById($scope.domain.id);
               }
        }
        else {
           testDomainConnectionById($scope.domain.id);
        }
    };

    $scope.chooseGroups = function () {
        if ($scope.groupFilterSource =="UA") {
            $scope.domain.groupUaFilter = '';
            $scope.domain.groupUaDNFilter = '';
            $scope.allGroupsConfig.selectedItems.forEach(function (group) {
                $scope.domain.groupUaFilter += (group.name + ',');
                $scope.domain.groupUaDNFilter += (group.dn + '##');
            });
            if ($scope.domain.groupUaFilter) {
                $scope.domain.groupUaFilter = $scope.domain.groupUaFilter.substring(0, $scope.domain.groupUaFilter.length - 1);
                $scope.domain.groupUaDNFilter = $scope.domain.groupUaDNFilter.substring(0, $scope.domain.groupUaDNFilter.length - 2);
            }
        }
        else {
            $scope.domain.groupFilter = '';
            $scope.domain.groupDNFilter = '';
            $scope.allGroupsConfig.selectedItems.forEach(function (group) {
                $scope.domain.groupFilter += (group.name + ',');
                $scope.domain.groupDNFilter += (group.dn + '##');
            });
            if ($scope.domain.groupFilter) {
                $scope.domain.groupFilter = $scope.domain.groupFilter.substring(0, $scope.domain.groupFilter.length - 1);
                $scope.domain.groupDNFilter = $scope.domain.groupDNFilter.substring(0, $scope.domain.groupDNFilter.length - 2);
            }
        }
        $scope.$root.closePopup('chooseGroupsDLg');
    };

    // Setting primitive values to null isn't marked as change on backend, so setting to empty string
    $scope.clearFilter = function (from) {
        if (from === 'VPN') {
            $scope.domain.groupFilter = "";
            $scope.domain.groupDNFilter = "";
        }
        else {
            $scope.domain.groupUaFilter = "";
            $scope.domain.groupUaDNFilter = "";
        }
    }

    $scope.enablePwChanage = function () {
        $scope.showEditPW = true;
    }

    $scope.openSyncDlg = function() {
        if ($scope.$root.hasChanges()) {
            if (confirm('You have unsaved changes.Do you want to save them first?')) {
                $scope.saveLDAP(doOpenSync);
            }else {
                doOpenSync();
            }
        }else {
            if (!$scope.domain.groupFilter) {
                $scope.$root.confirm("You haven't selected groups to import. Cato will now synchronize the entire directory. Do you want to continue?", function () {doOpenSync()});
            }
            else {
                doOpenSync();
            }
        }
    };

    $scope.syncAllDomains = function () {
      if ($scope.$root.hasChanges()) {
            $scope.$root.confirm('You have unsaved changes. Do you want to save them first?', saveChangesAndSync, 'Save', 'Sync',validateFiltersAndSync, null, true);
      }
       else {
             validateFiltersAndSync();
       }
    }

    //validates group filters are not empty and runs sync
    var validateFiltersAndSync = function() {
        var domainsWithNotFilter = getDomainsWithNotFilter();

        if (domainsWithNotFilter.length > 0) {
            $scope.$root.confirm("You haven't selected groups to import in the following domains: " + domainsWithNotFilter.toString() + ". Cato will now synchronize the entire directory. Do you want to continue?", function () {doOpenSyncAllDomains()});
        }
        else {
         doOpenSyncAllDomains();
      }
    };

    var saveChangesAndSync = function() {
        saveChanges();
        validateFiltersAndSync();
    };

    function getDomainsWithNotFilter() {
        var emptyDomains = [];

        // if the domain has no vpn filter or wmi controllers configured and no UA filter we should warn the user
        $scope.externalSystem.domains.forEach(function(domain){
            if(!domain.groupFilter || (!domain.groupUaFilter && domain.wmiDomainControllers.length > 0)) {
                emptyDomains.push(domain.name);
            }
        });

        return emptyDomains;
    }

   $scope.updateAllDomains = function () {
            $scope.progressReset = new Date().getTime();
            store.action({
                path: '/updateAllDomains',
                queryParams: { accountId: $state.params.accountId, progressId: $scope.progressId },
                success: function (data) {
                    $scope.viewRecords = false;
                    processDataFromResponse(data);
                },
            });
        };

    $scope.addWmiSource = function() {
        var newDc = $scope.showDomainControllerItem==='host' ? {id: GeneralUtilsService.getRandomId(), domainId:$scope.domain.id, subnet: $scope.subnetsConfigSingleSelect.selectedItems[0],showEditPW:true,
                                                                           username: $scope.newDomainController.username, pw:$scope.newDomainController.pw } :
                                                                  {id: GeneralUtilsService.getRandomId(), domainId:$scope.domain.id, host: $scope.newDomainController.host, port: $scope.newDomainController.port,showEditPW:true,
                                                                           username: $scope.newDomainController.username, pw:$scope.newDomainController.pw }
        var params = {'accountId': $state.params.accountId,'domainId': $scope.domain.id,'type':'WmiDomainController','save':true};
           $scope.loadingSaveNew = true;
           store.save({
               path: "/add",
               data: newDc,
               dataObj: 'json',
               queryParams: params,
               success: function(data) {
                   $scope.loadingSaveNew = false;
                   $scope.$root.handleServerResponse(data,"newDC", "Domain Controller added successfully");
                   if(data.status !== "ERROR"){
                       //$scope.tableConfig.selectedId = data.model.id;
                       $scope.wmicontrollersdatamodified = new Date().getTime();
                       $scope.$root.closePopup('addWmiSource');
                   }
               }
           });
      };

    $scope.subnetsConfigSingleSelect = {
        titleSearch: true,
        multiSelect: false,
        hideCheckboxes: true,
        actions: false,
        dataURL: function () {
            return '/subnets?f=1&accountId=' + $state.params.accountId;
        },
        showTable: false,
        fields: [
            { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Site', name: 'siteName', template: '<span>{{item.siteName}}</span>' },
            { label: 'Network', path: 'interfaceName', template: "<span>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>" },
            { label: 'IP', path: 'subnet', template: '<span>{{item.subnet}}</span>' }
        ],
        type: 'Subnet',
        selectedItems: [],
        pageSize: 5,
        onSelect: function (index, item) {},
    };

    // ctrl functions

    function doOpenSync() {
                $scope.progressReset = new Date().getTime();
        		store.fetch({
        			path: '/syncAllDomains',
        			queryParams: {accountId: $state.params.accountId },
        			success: function (data) {
                        processDataFromResponse(data);
        			},
        		});

        		$scope.$root.openPopup('syncDLg');
    }

   var doOpenSyncAllDomains = function () {
                $scope.progressReset = new Date().getTime();
                store.fetch({
                    path: '/syncAllDomains',
                    queryParams: { accountId: $state.params.accountId },
                    success: function (data) {
                        processDataFromResponse(data);
                    },
                });

                $scope.$root.openPopup('syncDLg');
    }


    //save external system configuration
    var saveChanges = function (callBack) {
        $scope.externalSystem.newSaveMethod = true;
        store.save({
            path: '/edit',
            data: $scope.externalSystem,
            dataObj: 'json',
            queryParams: { externalsystemconfigurationId: $scope.externalSystem.id, save: true },
            success: function (data) {
                $scope.$root.handleServerResponse(data, 'externalSystem', 'Directory Services configuration saved successfully');
                $scope.domainssdatamodified = new Date().getTime();

                if (data.status != 'ERROR') {
                    $scope.externalSystem = data.model;
                    reload();
                    if (callBack) {
                        callBack();
                    }
                }
            },
        });
    }

    //load external system configuration from current account and set first domain if no MULTI_DOMAIN tag is present
    function loadExternalSystems() {
        $scope.progressReset = new Date().getTime();
          store.fetch({
              path: '/getExternalSystems',
              queryParams: { accountId: $state.params.accountId },
              success: function (data) {
                  $scope.externalSystem = data;
                  reload();
                  $scope.$digest();
                },
          });
      }

    //save original object and change controllers tables data modified to trigger table data fetch only after the domain is loaded
    function reload() {
      //Single domain support
         $ctrl.original = angular.copy($scope.externalSystem);
         $scope.controllersdatamodified = new Date().getTime();
         $scope.wmicontrollersdatamodified = new Date().getTime();
         $scope.uaExceptionsmodified = new Date().getTime();
         $scope.domainsdatamodified = new Date().getTime();
        if($scope.externalSystem !=null & $scope.externalSystem.scimProvisioning != null
            && $scope.externalSystem.scimProvisioning[0] != null &&
            $scope.externalSystem.scimProvisioning[0].scimProvisioningEnabled != null &&
            $scope.externalSystem.scimProvisioning[0].scimProvisioningEnabled){
            $scope.domainsConfig.scimEnabled = true;
        }else{
            $scope.domainsConfig.scimEnabled = false;
        }
    }

    function testWmiConnection(item) {
        $scope.progressReset = new Date().getTime();
        store.fetch({
            path: '/testWmiConnection',
            queryParams: { dcId: item.id },
            success: function (data) {
                processDataFromResponse(data);
                },
            });

        $scope.$root.openPopup('syncDLg');
    }

    function subnetExistsInDCs(subnet){
        var foundSubnet = false;
        $scope.domain.domainControllers.forEach(function (controller){
            if(angular.equals(controller.subnet, subnet))
                foundSubnet = true;
        });

        return foundSubnet;
    }

    function createNewDomain(){
        $scope.domain = {name: "New Domain",id: GeneralUtilsService.getRandomId()};
        $scope.externalSystem.domains[0] = $scope.domain;

    }

    function removeUnselectedDomainControllers() {
       var controllerTableItems = angular.copy($scope.controllersConfig.items);
       var unselectedItems = [];

        // remove un-selected items from table
       for( var i = controllerTableItems.length - 1 ; i >= 0 ; i--) {
           var controller = controllerTableItems[i];
           if (controller.subnet) {
               if (!itemExists($scope.subnetsConfig.selectedItems,controller.subnet)) {
                   $scope.controllersConfig.items.splice(i,1);
                   if(controller.id > 0){
                       unselectedItems.push(controller);
                   }
               }
           }
       }
       //add un selected items to items to delete
       GeneralUtilsService.addItemsToDelete($scope.domain, unselectedItems, "domainControllers");
    }

    function addSelectedDomainControllers() {
     // add newly selected items
        $scope.subnetsConfig.selectedItems.forEach(function (subnet) {
            if (!subnetExistsInDCs(subnet)) {
                var newDC = { id: GeneralUtilsService.getRandomId(), subnet: subnet, siteName: subnet.siteName };
                $scope.controllersConfig.items.push(newDC);
                $scope.domain.domainControllers.push(newDC);
            }
        });
    }


    function itemExists(collection, item) {
        var exists = false;

        collection.forEach( function(i) {
            exists = exists || angular.equals(i, item);
        });

        return exists;
    }

    $scope.$on('$reset-popup-params', ()  => {
        resetPopupParams();
    });

    $scope.$on('$destroy', function () {
        IntervalService.cancelDynamicInterval($scope.$id + $scope.progressReset, 'directoryServiceProgress');
    });
}



